module.exports = __webpack_public_path__ + "static/media/swisschard.b2a45076.webp";